module.exports = __webpack_public_path__ + "static/media/Noticias1.f4917a8f.svg";